import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted } from "vue";
import screenfull from "screenfull";
import { useTabsStore } from "@/store/tabs";
import { useSystemStore } from "@/store/system";
import { getMecVenue } from "./api/venue";
import { Local } from "./utils/storage";
import { useSocket } from "@/hooks/useSocket";
import { ElNotification } from "element-plus";
// import router from "./router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useTabsStore();
const systemStore = useSystemStore();

const { connect, on, off, disconnect } = useSocket();

// 在需要的时候连接
connect();
onMounted(() => {
  screenfull.on("change", changeFullscroll);
  systemStore.getCategorys();
  systemStore.getVenueAreaList();
  getVenueInfo();
  on("mec_event", handlerSocketEvent);
});
onUnmounted(() => {
  screenfull.off("change", changeFullscroll);
  off("mec_event", handlerSocketEvent);
  disconnect();
});

function handlerSocketEvent(data: any) {
  if (data.type == "mec_event") {
    ElNotification({
      title: "用户预约",
      message: data.data,
      duration: 0,
    });
  }
}
function getVenueInfo() {
  if (["mall"].includes(Local.get("type"))) {
    return;
  }
  if (!Local.get("current_venue") && Local.get("managerInfo")) {
    if (Local.get("current_mechanism")) {
      getMecVenue().then((res: ResultData) => {
        if (res.data.length > 0) {
          Local.set("current_venue", res.data[0]);
          if (res.data[0].categories_child.includes("台球")) {
            Local.set("mode", "tq");
          } else {
            Local.set("mode", "base");
          }
        } else {
          // router.push("/venue/venue");
        }
      });
    }
  }
}
function changeFullscroll() {
  store.is_fullScroll = screenfull.isFullscreen;
}

const debounce = (fn: object, delay: number) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: object) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})